export const enum ErrorMessages {
    INVALID_USER = 'Invalid User',
}
